// extracted by mini-css-extract-plugin
export var content = "styles-module--content--6e2bf";
export var infoText = "styles-module--infoText--e5097";
export var productVariant = "styles-module--productVariant--a1000";
export var subtitle = "styles-module--subtitle--9b872";
export var textContainer = "styles-module--textContainer--b3cf2";
export var title = "styles-module--title--95f84";